export class SelectInPopoverOption {
  isSelected?: boolean;

  constructor(public label: string) {}
}
